import { render, staticRenderFns } from "./ResourceFoundIn.vue?vue&type=template&id=476fed7b"
import script from "./ResourceFoundIn.vue?vue&type=script&lang=js"
export * from "./ResourceFoundIn.vue?vue&type=script&lang=js"
import style0 from "./ResourceFoundIn.vue?vue&type=style&index=0&id=476fed7b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports